/**************************************************
 * Nombre:       Home_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import car_uno from '../../../Recursos/car_uno.png'
import car_dos from '../../../Recursos/car_dos.png'
import car_tres from '../../../Recursos/car_tres.png'
import car_cuatro from '../../../Recursos/car_cuatro.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Home_Caracteristicas = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >


            {items.map((item, index) => (
                <Grid container size={{xs: 6, sm: 3, md: 3}} sx={{justifyContent: 'flex-start', overflow: 'hidden'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            background: `linear-gradient(180deg, rgba(124, 140, 82, 0.00) 0%, #7C8C52 100%), url(${item.img})`,
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            p: sCell ? 2 : 4,
                            color: '#fff',
                            transition: 'transform 0.8s ease',
                            '&:hover': {
                                transform: 'scale(1.05)',
                            }
                        }}
                        spacing={0}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: !masSM ? 25 : 50}}>
                            <Typography sx={{fontSize: !masSM ? 12 : 16}}>{item.nombre}</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontWeight: 800,
                                fontSize: !masSM ? 18 : 30,
                                lineHeight: 1.2,
                                height: !masSM ? 40 : 80
                            }}>{item.descripcion}</Typography>
                        </Grid>

                    </Grid>
                </Grid>
            ))}

        </Grid>
    )

}
export default Home_Caracteristicas

const items = [
    {
        img: car_uno,
        nombre: 'Responsabilidad',
        descripcion: 'Reforestación'
    },
    {
        img: car_dos,
        nombre: 'Empatia',
        descripcion: 'No deforestación'
    },
    {
        img: car_tres,
        nombre: 'Eficiencia',
        descripcion: 'Aprovechamiento de residuos'
    },
    {
        img: car_cuatro,
        nombre: 'Cumplimiento',
        descripcion: 'Cumplimiento internacional'
    },
]